import { render } from "./AsetTambahModal.vue?vue&type=template&id=5290bcc9"
import script from "./AsetTambahModal.vue?vue&type=script&lang=js"
export * from "./AsetTambahModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__